import React, { Component } from "react";
import MainLayout from "../../Components/Layouts/MainLayout";
import CardBlock from "../../Components/CardBlock";
import Spinner from "../../Utils/Spinner";
import "rc-datepicker/lib/style.css";
import Functions from "../../Utils/Functions";
import CertificatesList from "../../Components/CertificatesList";
import { DataContext } from "../../Contexts/DataContexts";

export default class VetIssuedCertificatesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      errorMessage: null,
    };
  }

  static contextType = DataContext;

  componentDidMount() {}

  render() {
    return (
      <MainLayout title="Issued Certificates">
        <div className="row">
          <div className="col-md-12 mb-5">
            <CardBlock>
              <CertificatesList issuedBy={this.context.globalState.user.id} />
            </CardBlock>
          </div>
        </div>
      </MainLayout>
    );
  }
}
